module.exports = __webpack_public_path__ + "img/img_offreurs_partenaires_engages_sepem.b5cb9bc1.png";